import { HttpsAuthContext, HttpsCallable } from './https-callable.js';

export abstract class ICloudFunctionsProvider {
  abstract getHttpsCallable(functionName: string, context: HttpsAuthContext): HttpsCallable;
}
